

export abstract class InjectableService {

    abstract get injectableKey(): string;

}


export interface InjectableCtor<T extends InjectableService> {
    new(...args: any[]): T;
    readonly injectableKey: string;
}
